import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "OwnerBlockRequestTargetDashboardPage" */
	'pages/sales/OwnerBlockRequestTarget/OwnerBlockRequestTargetDashboardPage'));

export default [{ component, exact: true, path: '/owner_block_request_targets/:ownerBlockRequestTargetId' }];